import '../common/BackLayout/BackLayout.css';
import './PostcardContainer.css';
import '../common/FrontLayout/FrontLayout.css';

import * as React from 'react';

import { IPlaceHolder, IDocument, ISpread, IDragInfo, IPage } from '../../../../../infrastructure/interfaces';
import { PageType } from '../../../../../infrastructure/PageType';
import BackLayout from '../common/BackLayout';
import FrontLayout from '../common/FrontLayout';
import PageLayout from './Components/PageLayout';
import PagePlaceholder from '../common/PagePlaceholder';

export interface IPostcardProps {
  document: IDocument | null;
  spread: ISpread;
  disclaimers: any[];
  isPDFRender: boolean;
  handleDrop(index: number, data: IPlaceHolder, dragInfo: IDragInfo): void;
  removeProduct(data: any, index: number): void;
  moveCrop?(dragIndex: number, hoverIndex: number): void;
}

export default class PostcardContainer extends React.Component<IPostcardProps> {

  renderFront = () => {
    const {
      document,
      moveCrop,
    } = this.props;

    return (
      <FrontLayout
        document={document}
        moveCrop={moveCrop}
        isSpreadView={true}
        isEditorRendering={true}
        isWebPageCover={true}
        mainView={true}
      />
    );
  }

  renderPage(page: IPage) {
    return (
      this.props.isPDFRender
      ? (
          // PDFs won't render in drag and drop containers, which PageLayout uses.
          page.placeholders.map((p, i) => {
            return (
              <div
                key={page.number}
                className={`Poster left crop-page-view-drop isDropped`}
                data-pagenumber={page.number}
              >
                <PagePlaceholder
                  removeProduct={this.props.removeProduct}
                  index={i}
                  model={p}
                  isEditorView={false}
                  pageNumber={page.number}
                  document={this.props.document}
                />
              </div>
            );
          })
        )
      : (
          <PageLayout
            page={page}
            removeProduct={this.props.removeProduct.bind(this)}
            handleDrop={this.props.handleDrop}
            document={this.props.document}
          />
        )
      );  
  }

  renderBack = () => {
    return (
      <BackLayout
        document={this.props.document}
        brandings={this.props.document!.brandings}
        isEditorRendering={true}
        isWebPageCover={true}
        disclaimers={this.props.disclaimers}
      />
    );
  }

  renderSpread(spread: ISpread) {
    if (spread === null) {
      return (
        <div className="postcard-product-page-wrapper"></div>
      );
    }

    if (spread.left && spread.right) {
      if (spread.left.type === PageType.Front && spread.right.type === PageType.Page) {
        return (
          <div className="postcard-product-page-wrapper">
            <div className={`crop-cont--postcard`}>
              {this.renderFront()}
              {this.renderPage(spread.right)}
            </div>
          </div>
        );
      } else {
        return (
          <div className="postcard-product-page-wrapper">
            <div className={`crop-cont--postcard`}>
              {this.renderBack()}
            </div>
          </div>
        );
      }
    }
    return (
      <div className="postard-product-page-wrapper"></div>
    );
  }

  render() {
    return (
      this.renderSpread(this.props.spread)
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Editor/components/CropPageView/Postcard/PostcardContainer.tsx